/**
 * UK QWERTY (Windows KBDUK / Unicode CLDR `en-GB-t-k0-windows`): maps a physical code to the
 * unshifted character that key emits. The letter and number rows match US QWERTY; the ISO board
 * differs only around Enter: the key left of Enter (code Backslash) is the "#/~" key, and the
 * extra ISO key by left Shift ("\\|", IntlBackslash) is outside the US-Qwerty code block. Letters
 * uppercase by table convention.
 */
export const UK_QWERTY_CODE_TO_CHAR: Record<string, string> = {
  Backquote: "`",
  Digit1: "1",
  Digit2: "2",
  Digit3: "3",
  Digit4: "4",
  Digit5: "5",
  Digit6: "6",
  Digit7: "7",
  Digit8: "8",
  Digit9: "9",
  Digit0: "0",
  Minus: "-",
  Equal: "=",
  KeyQ: "Q",
  KeyW: "W",
  KeyE: "E",
  KeyR: "R",
  KeyT: "T",
  KeyY: "Y",
  KeyU: "U",
  KeyI: "I",
  KeyO: "O",
  KeyP: "P",
  BracketLeft: "[",
  BracketRight: "]",
  Backslash: "#", // UK ISO "#/~" key (code Backslash)
  KeyA: "A",
  KeyS: "S",
  KeyD: "D",
  KeyF: "F",
  KeyG: "G",
  KeyH: "H",
  KeyJ: "J",
  KeyK: "K",
  KeyL: "L",
  Semicolon: ";",
  Quote: "'",
  KeyZ: "Z",
  KeyX: "X",
  KeyC: "C",
  KeyV: "V",
  KeyB: "B",
  KeyN: "N",
  KeyM: "M",
  Comma: ",",
  Period: ".",
  Slash: "/",
};

/**
 * The .SC2Hotkeys serialization token per code where UK QWERTY's token diverges from charToken of
 * its character. Three keys differ from US QWERTY by virtual-key: the "'/@"
 * key is VK_OEM_3, which SC2 names "Grave"; the "`/not" key is VK_OEM_8, named "OEM8". TheCore maps
 * any US backslash binding onto Enter on this ISO layout (the ANSI "\\|" key has no home), so the
 * Backslash code serializes as the positional token "Enter" - recovered from TheCore's real UK files
 * (both hands) and verified command-for-command. Letters and digits are positional/char-path and
 * omitted; the map is injective. The right-hand file's only "`"-key binding (ChatAllies) is left on
 * "Grave" unconverted, a documented source quirk; the OEM8 token is witnessed by the left-hand file.
 */
export const UK_QWERTY_CODE_TO_TOKEN: Record<string, string> = {
  Backquote: "OEM8", // "`/not" key, VK_OEM_8
  Quote: "Grave", // "'/@" key, VK_OEM_3
  Backslash: "Enter", // ISO: US backslash bindings remap to Enter
};
